<app-successful-payment
  title="Успешно!"
  [sendClock]="false"
  [message]="'Кредит выдан'"
  [subMessages]="['Документы отправлены на обработку.', 'Через несколько минут средства будут перечислены на Ваш счет.']"
  [id]="id"
  (pageCanLeave)="false"
  (cancel)="cancel()"
>
</app-successful-payment>
